var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuCollapse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "dock_to_left"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27003_1259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27003_1259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dock_to_left_2",
    d: "M4.42311 17.0833C4.00756 17.0833 3.65256 16.9362 3.35811 16.6419C3.06381 16.3474 2.91666 15.9924 2.91666 15.5769V4.42313C2.91666 4.00757 3.06381 3.65257 3.35811 3.35813C3.65256 3.06382 4.00756 2.91667 4.42311 2.91667H15.5769C15.9924 2.91667 16.3474 3.06382 16.6419 3.35813C16.9362 3.65257 17.0833 4.00757 17.0833 4.42313V15.5769C17.0833 15.9924 16.9362 16.3474 16.6419 16.6419C16.3474 16.9362 15.9924 17.0833 15.5769 17.0833H4.42311ZM13.3333 15.8333H15.8333V4.42313C15.8333 4.35896 15.8066 4.30021 15.7531 4.24688C15.6998 4.1934 15.641 4.16667 15.5769 4.16667H13.3333V15.8333ZM12.0833 15.8333V4.16667H4.42311C4.35895 4.16667 4.3002 4.1934 4.24687 4.24688C4.19339 4.30021 4.16666 4.35896 4.16666 4.42313V15.5769C4.16666 15.641 4.19339 15.6998 4.24687 15.7531C4.3002 15.8066 4.35895 15.8333 4.42311 15.8333H12.0833Z",
    fill: "#4F5B68"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuCollapse);
export default __webpack_public_path__ + "static/media/icon-menu-collapse.f22b214d02d53661927b268208469132.svg";
export { ForwardRef as ReactComponent };